import client from '../client';
import * as clientQueries from "../queries/client";
import * as clientMutations from "../mutations/client";

export function getClients(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: clientQueries.all,
    })
    .then(success)
    .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, client: data },
        mutation: clientMutations.edit,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { client: data },
        mutation: clientMutations.add,
    }).then(success).catch(error);;
}


// WEBPACK FOOTER //
// ./src/graphql/actions/client.js